import { render, staticRenderFns } from "./PatientsFormInterviews.vue?vue&type=template&id=3d3857a3&"
import script from "./PatientsFormInterviews.vue?vue&type=script&lang=js&"
export * from "./PatientsFormInterviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports